import { ChatInboxWorkspace } from '@/features/ChatInbox/ui/ChatInboxWorkspace';

/** Показывает общую переписку с пользователями */
export const ChatPage = () => <ChatInboxWorkspace />;
